function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M127.6 262.3v-85H0v85h55.5v7H21.3v14.2h85v-14.2H72.1v-7h55.5zm-99.1-56.6h70.6v28H28.5v-28zM283.5 262.3v-85H155.9v85h55.5v7h-34.2v14.2h85v-14.2H228v-7h55.5zm-99.1-56.6H255v28h-70.6v-28zM205.5 85V0H78v85h55.5v7H99.2v14.2h85V92H150v-7h55.5zm-99-56.5H177v28h-70.6v-28zM21.2 127.7h28.3V156H21.2zM21.2 78.2h28.3v28.3H21.2zM21.2 28.5h28.3v28.3H21.2zM234 127.7h28.3V156H234zM234 78.2h28.3v28.3H234zM234 28.5h28.3v28.3H234z"
})));